import React from 'react';
import { Paper, Typography, Divider, Grid, Box } from '@mui/material';

/**
 * Mirrors the "LOAN SUMMARY" block on the printed form, including the
 * two rows the previous version was missing: Total Penalties and Loan Offset.
 */
const Row = ({ label, value, bold, color }) => (
  <>
    <Grid item xs={7}>
      <Typography variant="body2" sx={bold ? { fontWeight: 'bold' } : undefined}>
        {label}
      </Typography>
    </Grid>
    <Grid item xs={5}>
      <Typography
        variant="body2"
        align="right"
        sx={{ ...(bold ? { fontWeight: 'bold' } : {}), ...(color ? { color } : {}) }}
      >
        {value}
      </Typography>
    </Grid>
  </>
);

const LoanSummary = ({ loanSummary, formatCurrency }) => {
  const l = loanSummary || {};

  return (
    <Paper sx={{ p: 2, height: '100%' }} data-testid="loan-summary">
      <Typography variant="h6" gutterBottom color="primary">
        LOAN SUMMARY
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ mb: 2 }}>
        <Grid container spacing={1}>
          <Row label="Loans b/f" value={formatCurrency(l.loansBF)} />
          <Row label="Loans Given" value={formatCurrency(l.loansGiven)} />
          <Row label="Total Penalties" value={formatCurrency(l.totalPenalties)} />
          <Row label="Total" value={formatCurrency(l.total)} bold />
          <Row label="Less Loans Paid" value={formatCurrency(l.lessLoansPaid)} />
          <Row label="Loan Offset" value={formatCurrency(l.loanOffset)} />
          <Row
            label="Net Loan c/f"
            value={formatCurrency(l.netLoanCF)}
            bold
            color="error.main"
          />
        </Grid>
      </Box>
    </Paper>
  );
};

export default LoanSummary;